import React from "react";

const IconDefaultError = () => {
  return (

    <svg width="108" height="63" viewBox="0 0 108 63" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 60.25H0" stroke="#EC111A" stroke-width="2" />
      <path d="M55 62.75C65.4934 62.75 74 61.6307 74 60.25C74 58.8693 65.4934 57.75 55 57.75C44.5066 57.75 36 58.8693 36 60.25C36 61.6307 44.5066 62.75 55 62.75Z" fill="#F6F6F6" />
      <path d="M108 60.25H84" stroke="#EC111A" stroke-width="2" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M74.9182 43.7368C75.6241 42.5263 71.989 28 54.9902 28C37.9914 28 34.4622 42.5263 35.0622 43.7368C35.6621 44.9474 44.0498 51 55.002 51C65.9542 51 74.2124 44.9474 74.9182 43.7368Z" fill="#7849B8" />
      <path d="M54.5 25C60.299 25 65 20.299 65 14.5C65 8.70101 60.299 4 54.5 4C48.701 4 44 8.70101 44 14.5C44 20.299 48.701 25 54.5 25Z" fill="#7849B8" />
    </svg>


  );
};
export default IconDefaultError;
